// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1511":"e35e4fc0","2276":"d083d0ca","7347":"62b0c8cf","8759":"9cb3ce37"}[chunkId] + ".chunk.css";
};